<template>
	<div class="home">
		<v-img :aspect-ratio="83/24" :src="require('../assets/banner.jpg')">
		</v-img>
		<div class="article">
			<h3>About LifeArt</h3>
			<p>LifeArt is the most interesting AI facial application. We have a lot of creative and interesting emoticons. They are created by talented designers and are updated regularly every week. At the same time, it has excellent AI filters, effects and other tools to create realistic edits with one click.</p>
			<div class="box_dev_img">
				<img src="../assets/comcrt_1.jpg">
				<img src="../assets/comcrt_2.jpg">
				<img src="../assets/comcrt_3.jpg">
				<img src="../assets/comcrt_4.jpg">
			</div>
			<h3>#Create your emoji#</h3>
			<p>Share your personal emojis to any social network or messenger: WhatsApp, Facebook, Facebook Messenger, Instagram, Instagram Stories, Snapchat, Telegram, Twitter, etc.</p>
			<h3>#Cartoon Avatar#</h3>
			<p>One-click generation of cartoon faces, creating a personal cartoon image, and taking you into the world of comics. The amazing effect will exceed your imagination.</p>
			<h3>#Fun Test#</h3>
			<p>Want to know how old you look like? How many points do you look like? Passing these tests allows you to understand yourself better in other ways.</p>
			<h3>#Swap Your Gender#</h3>
			<p>Be curious to see your other gender face?Take a selfie and the function will let you see what would you look like when you were another gender. It is very amazing!</p>
			<h3>#Fancy Hair Color#</h3>
			<p>Adjust the color of each hairstyle at will, and easily find the hair color that makes you the most beautiful or handsome.</p>
			<h3>#Time Travel#</h3>
			<p>Have you ever imagined what you will look like when you get old?Have you ever dreamed about turning back time and being a kid again?You can realize your dream here.</p>
			<h2>About ECSMOBI LIMITED</h2>
			<p>After years of technology precipitation and experience accumulation, technology business includes computer software and hardware, network product technology development, technical consulting, technical services; information system design, integration, operation and maintenance; Internet information technology development and technical consulting; operating e-commerce; Web page design; economic information consulting; investment consulting; computer and network technology development; Internet community service, mobile Internet, mobile phone application technology development.</p>
		</div>
	</div>
</template>
<script>
	export default {
		name: 'home',
		components: {}
	}
</script>

<style scoped>
	.article{
		margin-left: 50px;
	}
	.box_dev_img > img{
		width: 25%;
		height: 25%;
	}
</style>>